<template>
	<div class="v-application">
		<headerNav @handleBrage="handleBrage"></headerNav>
		<div class="v-application-wrapper">
			<div class="v-application-container">
				<sideBar ref="sideBarRef" :menuUrl="'refund'"></sideBar>
				<div class="v-content-white-wrapper">
					<div class="table-container">
						<div class="card-header">
							<h1 class="fs-20">{{$t('menu.refundrequest')}}</h1>
						</div>

						<div class="product-infos-wrapper-pc">
							<el-table :data="refundOrderList" style="width: 100%" v-loading="tableLoading"
								:empty-text="$t('empty.nodata')">
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="product" :label="$t('table.date')"></el-table-column>
								<el-table-column prop="customer" :label="$t('table.orderid')"></el-table-column>
								<el-table-column prop="rating" :label="$t('table.product')"></el-table-column>
								<el-table-column prop="comment" :label="$t('table.amount')"></el-table-column>
								<el-table-column prop="published" :label="$t('table.status')">
									<template v-slot="scope">
										<el-tag type="success">{{$t('table.published')}}</el-tag>
									</template>
								</el-table-column>
								<el-table-column prop="comment" :label="$t('table.reason')"></el-table-column>
								<el-table-column prop="comment" :label="$t('table.approval')"></el-table-column>
								<el-table-column prop="comment" :label="$t('table.reject')"></el-table-column>
							</el-table>
						</div>

						<div class="product-infos-wrapper-mobile">
							<el-table :data="refundOrderList" style="width: 100%" v-loading="tableLoading"
								:empty-text="$t('empty.nodata')">
								<el-table-column type="expand">
									<template v-slot="scope">
										<div class="expanded-content">
											<p><strong>{{$t('table.date')}}:</strong> {{ scope.row.product }}</p>
											<p><strong>{{$t('table.product')}}:</strong> {{ scope.row.comment }}</p>
											<p><strong>{{$t('table.amount')}}:</strong> {{ scope.row.published }}</p>
											<p><strong>{{$t('table.status')}}:</strong> {{ scope.row.published }}</p>
										</div>
									</template>
								</el-table-column>
								<el-table-column type="index" width="50" label="#"></el-table-column>
								<el-table-column prop="customer" :label="$t('table.orderid')"></el-table-column>
								<el-table-column prop="rating" :label="$t('table.approval')"></el-table-column>
							</el-table>
						</div>
						<!-- 分页组件 -->
						<div class="page-contrainer d-flex">
							<el-pagination background :page-count="isMobile ? 4 : 10" layout="prev, pager, next"
								:total="total" :current-page.sync="queryParams.pageNum"
								@current-change="getRefundOrderList"></el-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
		<tabBar ref="tabBarRef"></tabBar>
	</div>
</template>

<script>
	import headerNav from '../../components/headerNativation.vue'
	import sideBar from '../../components/sideBar.vue'
	import tabBar from '../../components/tabBar.vue'
	import {
		refundlist
	} from '../../api/order.js'

	export default {
		components: {
			headerNav,
			sideBar,
			tabBar
		},
		data() {
			return {
				tableLoading: false,
				refundOrderList: [],
				total: 0,
				queryParams: {
					pageNum: 1,
					pageSize: 10,
				},
				isMobile: false
			}
		},
		created() {
			this.isMobile = this.webIsMobile()
			this.getRefundOrderList()
		},
		methods: {
			handleBrage(){
				this.$refs.sideBarRef.handleBrage()
				this.$refs.tabBarRef.handleBrage()
			},
			getRefundOrderList() {
				this.tableLoading = true
				refundlist(this.queryParams).then(res => {
					this.tableLoading = false
					if (res.code == 200) {
						this.refundOrderList = res.rows
						this.total = res.total
					}
				})
			},
			// 	currentPage 改变时会触发
			handleCurrentChange(currentPage) {
				this.pageNo = currentPage;
			},
			// 	用户点击上一页按钮改变当前页后触发
			handlePrevClick(currentPage) {
				this.pageNo = currentPage;
			},
			// 用户点击下一页按钮改变当前页后触发
			handleNextClick(currentPage) {
				this.pageNo = currentPage;
			},
		}
	}
</script>

<style scoped>
	@import url("../../assets/css/review.css");
</style>
<style scoped>
	.product-infos-wrapper-mobile {
		display: none;
	}

	.product-infos-wrapper-pc {
		display: block;
	}

	@media (max-width: 768px) {
		.product-infos-wrapper-mobile {
			display: block;
		}

		.product-infos-wrapper-pc {
			display: none;
		}

	}
</style>
